import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { PrimarySkeleton } from 'src/Components/Skeletons/PrimarySkeleton'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 120px 240px;
  grid-column-gap: 16px;
  grid-row-gap: 16px;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    display: flex;
    flex-direction: column;
  }
`
const TopSkeleton = styled(PrimarySkeleton)`
  grid-area: 1 / 1 / 2 / 3;
  height: 120px;
`
const LeftSkeleton = styled(PrimarySkeleton)`
  grid-area: 2 / 1 / 3 / 2;
  height: 240px;
`
const RightSkeleton = styled(PrimarySkeleton)`
  grid-area: 2 / 2 / 3 / 3;
  height: 240px;
`

export const ScheduleSettingsPageSkeleton: FC = () => (
  <Grid>
    <TopSkeleton />
    <LeftSkeleton />
    <RightSkeleton />
  </Grid>
)
